// 导入
import Vue from "vue";
import Cookies from "js-cookie";
// 抹平各浏览器的差异
import "normalize.css/normalize.css"; // A modern alternative to CSS resets
// // 引入组件样式
// import "sv-print/dist/style.css";
// 全局loading
import {
  showFullScreenLoading,
  tryHideFullScreenLoading,
} from "@/utils/loading";
import { getAttributeLabel } from "./utils/index.js";
Vue.prototype.$showFullScreenLoading = showFullScreenLoading;
Vue.prototype.$tryHideFullScreenLoading = tryHideFullScreenLoading;
Vue.prototype.getAttributeLabel = getAttributeLabel;
window.showPageLoading = showFullScreenLoading;
window.tryPageLoading = tryHideFullScreenLoading;

// 初始化WebAssembly
import WasmInit from "@/utils/wasmInit";
WasmInit.initWebAssembly();

// 导入并初始化全局数字键盘（用于移动端替代系统输入法）
// 直接从新的初始化文件导入，避免通过index.js导入
import { setupGlobalNumericKeypad } from "@/examples/keyboardSetup";
setupGlobalNumericKeypad();

// 表格组件
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
import "@/styles/VXETable.scss";
Vue.use(VXETable);
//toopltip层级最高不被遮挡
VXETable.config({
  zIndex: 3000,
});

import App from "./App";
import store from "./store";
import router from "./router";
import "@/icons"; // 导入icon图标
import "@/permission"; // 导航守卫

// 自定义指令
import directives from "@/directives";
Object.keys(directives).forEach((item) => {
  Vue.directive(item, directives[item]);
});

// 密码加密
import jsencrypt from "@/utils/encryption"; //注意文件路径，实际路径以项目目录结构为准
Vue.prototype.$jsencrypt = jsencrypt;
// base64加密调用
import { Base64 } from "js-base64";
Vue.prototype.$Base64 = Base64;

Vue.config.productionTip = false;

// $bus挂载方法
Vue.prototype.$bus = new Vue();

// ElementUI的使用 1.安装 2.导入element-ui 导入css 3.注册 Vue.use(导入element)
import ElementUI from "element-ui";
// 防止dialog导致页面滚动条消失抖动
ElementUI.Dialog.props.lockScroll.default = false;

import "element-ui/lib/theme-chalk/index.css";
// 导入全局的css
import "@/styles/index.scss"; // global css
import "@/styles/element-ui.scss";

// 引入websocket连接
import socketApi from "@/mixins/socket"; //找到封装的socket.js文件
Vue.prototype.$socketApi = socketApi; //将其挂在原型上，这样 $socketApi就在所有的 Vue 实例中可用了。

Vue.use(ElementUI);
Vue.use(ElementUI, {
  size: Cookies.get("size") || "medium",
});
import oneMessage from "@/utils/oneMessage";
ElementUI.Dialog.props.lockScroll.default = false; // 打开弹窗防止页面抖动
Vue.prototype.$message = oneMessage;

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
